import { CartsByCartId } from '@comicrelief/data-models/schemas/payments/models/Cart';
import { cartsApi } from '.';

export interface CartsDataResponse {
  data: CartsByCartId,
  message: string,
}

const extendedCartsApi = cartsApi.injectEndpoints({
  endpoints: builder => ({
    getCartsData: builder.query<CartsDataResponse, { environment?: string }>({
      query: ({ environment = 'master' }) => `carts?environment=${environment}`
    })
  })
});

export const { useGetCartsDataQuery } = extendedCartsApi;
